<template>
  <a data-testid="toggle-favorite-off"  :class="linkClass" @click="favoriteItem" href="#">
    <div :class="['star-icon', iconClass]"></div>
  </a>
</template>

<script>

// this component handles the favorite item requests using the yellow/gray star icon
// both in desktop item cards and viewer
import track from '@/src/tracking';

export default {
  props: {
    itemId: [Number,String],
    isFavorite: Boolean,
  },
  data: function() {
    return {
      favorite: Boolean,
    }
  },
  computed: {
    iconClass: function() { return !!this.favorite ? 'active' : 'inactive' },
    linkClass: function() { return !!this.favorite ? 'unfavorite-item' : ''}
  },
  methods: {
    favoriteItem: function(){
      const vm = this;
      this.$store.dispatch('favoriteItem', this.itemId)
        .then((response) => {
          const favorite = response?.data?.data?.items[0]?.attributes?.favorite || !this.favorite;
          vm.favorite = favorite;
          if(window.location.pathname.split('/')[1] == 'dashboard'){
            track('tile_favourite')
          }   
        })
        .catch((error) => {
          vm.$root.toastError('Could not favorite item, please try again.');
          console.log(error);}
        )
    },
  },
  created: function() {
    this.favorite = this.isFavorite;
  }
}
</script>
<style lang="scss" scoped>
  .star-icon{
      background:url("@img/star_default.svg") no-repeat;
      width:1rem;
      height: 1rem;
      display: inline-block;
      line-height: 1;
      &.inactive:hover{
        background: url("@img/star_hover.svg") no-repeat;
      }
      &.active{
       background: url("@img/star_active.svg") no-repeat;
      }
  }
  </style>